<div class="bulk-upload-processing" *ngIf="view$ | async as view">
  <p class="bulk-upload-processing__names" [title]="view.fileNames">{{ view.fileNames }}</p>
  <p class="bulk-upload-processing__title">
    {{ 'Processing files ({{count}})...' | translate: { count: view.fileCount } }}
  </p>

  <div class="bulk-upload-processing__summary">
    <div class="bulk-upload-processing__progress-bar progress">
      <div
        class="bulk-upload-processing__progress-value progress-bar"
        [class.progress-bar-animated]="view.progress !== 100"
        [class.progress-bar-striped]="view.progress === 100"
        [style.width]="view.progress + '%'"
      ></div>
    </div>
  </div>

  <ng-container *ngIf="view.failedFileNames.length; else processingInfo">
    <div class="bulk-upload-processing__error-list">
      <div class="bulk-upload-processing__error-item" *ngFor="let fileName of view.failedFileNames">
        <app-pencil-icon
          class="bulk-upload-processing__error-icon"
          [name]="'cancel'"
          [type]="IconTypes.materialIcon"
          [outlined]="true"
        >
        </app-pencil-icon>
        <span class="bulk-upload-processing__error-name">{{ fileName }}</span>
        <span class="bulk-upload-processing__error-status">{{ 'failed' | translate }}</span>
      </div>
    </div>
  </ng-container>
  <ng-template #processingInfo>
    <p class="bulk-upload-processing__info" *ngIf="view.fileCount > 1; else largeFilesPrompt">
      <app-pencil-icon
        class="bulk-upload-processing__info-icon"
        [name]="'info_outline'"
        [type]="IconTypes.materialIcon"
      >
      </app-pencil-icon>
      {{ 'Processing multiple files may take a little extra time' | translate }}
    </p>
  </ng-template>
</div>

<ng-template #largeFilesPrompt>
  <p class="bulk-upload-processing__info">
    <app-pencil-icon
      class="bulk-upload-processing__info-icon"
      [name]="'info_outline'"
      [type]="IconTypes.materialIcon"
    >
    </app-pencil-icon>
    {{ 'Processing large files may take a little extra time' | translate }}
  </p>
</ng-template>
